import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Article} from "../../../../../backend";
import {RouterLink} from "@angular/router";
import {LazyLoadingComponent} from "../lazy-loading/lazy-loading.component";
import {TranslocoDirective} from "@ngneat/transloco";
import {LanguageConverterService} from "../../../service/language-converter.service";
import {DEFAULT_DATE_FORMAT} from "../../model/constatnt";
import {PageType} from "../../model/page-type";
import FileTypeEnum = Article.FileTypeEnum;
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-article-short-template',
  standalone: true,
  imports: [CommonModule, RouterLink, LazyLoadingComponent, TranslocoDirective, NgbTooltip],
  templateUrl: './article-short-template.component.html',
  styleUrl: './article-short-template.component.scss'
})
export class ArticleShortTemplateComponent{


  @Input()
  article!: Article

  @Input()
  template: PageType = PageType.LIST;

  constructor(private languageConverter: LanguageConverterService) {
  }

  public convertToCountry(value: string | undefined) {
    if (value === undefined) {
      return "";
    }
    return this.languageConverter.convertToCountry(value);
  }

  public concat(v1: string | undefined, v2: string | undefined): string {
    return (v1 === undefined ? "" : v1).concat(v2 === undefined ? "" : v2)
  }


  isTemplate(tmpl: PageType) {
    if (this.template === tmpl) {
      return true;
    }
    return false;
  }

  protected readonly DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  protected readonly PageType = PageType;

  isViewFilesAndAbstract(){
    return PageType.LIST === this.template;
  }

  isHasFiles(){
    return this.article.hasFile || this.article.hasHtml;
  }
  getFileType(){
    if (this.article.fileType === undefined){
      return undefined;
    }
    if (this.article.fileType === FileTypeEnum.PDF){
      return "pdf"
    }
    return "word";
  }

  getFontSizeClass() : string{
    if (PageType.LIST === this.template){
      return "font-size-default"
    }
    return "";
  }
  isGicid() : boolean{
    if (PageType.LIST === this.template){
      return true
    }
    return false;
  }

  isPanelLangaugesViewsIdentifiers() : boolean{
    if (PageType.MINIMAL === this.template){
      return false
    }
    return true;
  }

  hasFileAndFree() {
    if (this.article.hasFile === undefined || this.article.free === undefined){
      return false;
    }
    if (this.article.hasFile === null || this.article.free === null){
      return false;
    }
    if (!this.article.hasFile || !this.article.free){
      return false;
    }
    if (this.article.hasFile || this.article.free){
      return true;
    }
    return false;
  }

  isPages() {
    if (PageType.LIST !== this.template || this.article.pages === undefined || this.article.pages === null){
      return false;
    }
    return true;
  }

}
